export const ARTIST_NEXT_DOOR_LOGO = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/FINAL_LOGO.png`;
export const HAMBURGER_ICON = `${""}/HAMBURGER_ICON.svg`;
export const HAMBURGER_ICON_PURPLE = `${"ASSETS_URL"}/HAMBURGER_ICON_PURPLE.svg`;
export const HAMBURGER_ARROW = `${"ASSETS_URL"}/HAMBURGER_ARROW.svg`;

export const MUSICIAN = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/MUSICIAN.png`;
export const MAGICIAN = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/MAGICIAN.png`;
export const SINGER = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/SINGER.png`;
export const DANCER = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/DANCER.png`;
export const COMEDIAN = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/COMEDIAN.png`;
export const DJ = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/DJ.png`;
export const MUSICBAND = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/MUSICBAND.png`;
export const VIDEO_EDITOR = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/VIDEO_EDITOR.png`;
export const SPEAKER = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/SPEAKER.png`;
export const DANCE_GROUP = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/DANCE_GROUP.png`;
export const RAPPER = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/RAPPER.png`;
export const PHOTOGRAPHER = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/PHOTOGRAPHER.png`;

export const LOCATION_ICON = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/LOCATION_ICON.png`;
export const MUSIC_ICON = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/MUSIC_ICON.png`;
export const EXPERIENCE_ICON = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/EXPERIENCE_ICON.png`;
export const LIKE_DISLIKE_ICON = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/LIKE_DISLIKE_ICON.png`;
export const WHITE_DOWN_ICON = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/WHITE_DOWN_ARROW.png`;
export const BLUE_GIFT = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/BLUE_GIFT.png`;
export const GREEN_RS_SYMBOL = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/GREEN_RS_SYMBOL.png`;
export const GENDER_ICON = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/GENDER_ICON.png`;
export const FAQ_ARROW_DOWN = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/FAQ_ARROW_DOWN.webp`;
export const FAQ_ARROW_UP = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/FAQ_ARROW_UP.webp`;

export const ARTIST_1 = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/ARTIST_1.webp`;
export const ARTIST_2 = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/ARTIST_2.webp`;
export const ARTIST_3 = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/ARTIST_3.webp`;
export const ARTIST_4 = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/ARTIST_4.jpeg`;
export const ARTIST_5 = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/ARTIST_5.webp`;
export const DUMMY_ARTIST_PROFILE_PIC = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/DUMMY_ARTIST_PROFILE_PIC.jpg`;

export const SPOTIFY_LOGO_ICON = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/SPOTIFY_LOGO_ICON.png`;
export const FACEBOOK_LOGO_ICON = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/FACEBOOK_ICON.png`;
export const TWITTER_LOGO_ICON = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/TWITTER_ICON.png`;
export const TWITCH_LOGO_ICON = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/TWITCH_ICON.png`;
export const YELLOW_STAR = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/YELLOW_STAR.webp`;
export const REGISTER_MIKE = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/REGISTER_MIKE.jpg`;
export const LOGIN_HEADPHONE = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/LOGIN_HEADPHONE.jpg`;
export const PORTFOLIO = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/PORTFOLIO.jpg`;
export const SANSKAR = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/SANSKAR.png`;
export const MODI = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/MODI.png`;
export const AMIT_SHAH = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/AMIT_SHAH.png`;
export const CROWN = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/CROWN.png`;
export const TROPHY = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/TROPHY.png`;
export const AND_ARENA_TXT = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/AND_ARENA_TXT.png`;
export const VERSUS = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/VERSUS.png`;
export const ARTIST_NEXT_DOOR_ARENA = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/ARTIST_NEXT_DOOR_ARENA.jpg`;
export const ARITST_NEXT_DOOR_ARENA_GIFTS = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/ARITST_NEXT_DOOR_ARENA_GIFTS.jpg`;

export const VIDEO_EDITOR_AND_ARENA = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/VIDEO_EDITOR_AND_ARENA.jpeg`;
export const PHOTOGRAPHER_AND_ARENA = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/PHOTOGAPHER_AND_ARENA.jpeg`;
export const MAGIC_AND_ARENA = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/MAGIC_AND_ARENA.jpeg`;
export const DANCER_AND_ARENA = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/DANCER_AND_ARENA.jpeg`;
export const SINGER_AND_ARENA = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/SINGER_AND_ARENA.png`;
export const ARTIST_NEXT_DOOR_ARENA_ADVERT = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/ARTIST_NEXT_DOOR_ARENA_ADVERT.jpeg`;
export const ARTIST_NEXT_DOOR_DEFAULT_IMAGE = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/ARTIST_NEXT_DOOR_DEFAULT_IMAGE.jpeg`;

export const BLOG_POST_1 = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/BLOG_POST_1.png`;
export const BLOG_POST_2 = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/BLOG_POST_2.png`;
export const BLOG_POST_3 = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/BLOG_POST_3.png`;
export const BLOG_POST_4 = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/BLOG_POST_4.png`;
export const BLOG_POST_5 = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/BLOG_POST_5.png`;
export const BLOG_POST_6 = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/BLOG_POST_6.png`;
export const BLOG_POST_7 = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/BLOG_POST_7.png`;
export const BLOG_POST_8 = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/BLOG_POST_8.png`;
export const BLOG_POST_9 = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/BLOG_POST_9.png`;
export const BLOG_POST_10 = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/BLOG_POST_10.png`;
export const BLOG_POST_11 = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/BLOG_POST_11.png`;
export const BLOG_POST_11_a = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/BLOG_POST_11_a.png`;
export const BLOG_POST_11_b = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/BLOG_POST_11_b.png`;
export const BLOG_POST_11_c = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/BLOG_POST_11_c.png`;
export const BLOG_POST_11_d = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/BLOG_POST_11_d.png`;
export const BLOG_POST_12 = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/BLOG_POST_12.png`;
export const BLOG_POST_13 = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/BLOG_POST_13.png`;
export const BLOG_POST_14 = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/BLOG_POST_14.png`;
export const BLOG_POST_15 = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/BLOG_POST_15.png`;
export const BLOG_POST_16 = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/BLOG_POST_16.png`;
export const BLOG_POST_17 = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/BLOG_POST_17.png`;
export const BLOG_POST_18 = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/BLOG_POST_18.png`;
export const BLOG_POST_19 = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/BLOG_POST_19.png`;
export const BLOG_POST_20 = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/BLOG_POST_20.png`;
export const BLOG_POST_21 = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/BLOG_POST_21.png`;
export const BLOG_POST_22 = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/BLOG_POST_22.png`;
export const BLOG_POST_23 = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/BLOG_POST_23.png`;
export const BLOG_POST_24 = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/BLOG_POST_24.png`;

export const BLOG_POST_25 = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/BLOG_POST_25.png`;
export const BLOG_POST_26 = `https://andmediabucket.s3.us-east-1.amazonaws.com/and-files-firebaseToS3/BLOG_POST_26.png`;
export const BLOG_POST_27_MAIN =
  "https://andmediabucket.s3.amazonaws.com/blog-images/Post%2027.jpg";
export const BLOG_POST_27_SECTION1 =
  "https://andmediabucket.s3.amazonaws.com/blog-images/Post%2027%20-%20section%201.jpg";
export const BLOG_POST_27_SECTION4 =
  "https://andmediabucket.s3.amazonaws.com/blog-images/Post%2027%20-%20section%204.png";
export const BLOG_POST_27_SECTION7 =
  "https://andmediabucket.s3.amazonaws.com/blog-images/Post%2027%20-%20section%207.png";
export const BLOG_POST_27_FAQ =
  "https://andmediabucket.s3.amazonaws.com/blog-images/faq.png";

export const BLOG_POST_28_MAIN =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+28.png";
export const BLOG_POST_28_SECTION1 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+28+-+section+1.png";
export const BLOG_POST_28_SECTION3 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+28+-+section+3.png";
export const BLOG_POST_28_SECTION5 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+28+-+section+5.png";
export const BLOG_POST_28_SECTION10 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+28+-+section+10.png";

// Blog 29 images
export const BLOG_POST_29_SECTION2 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+29+-+section+2.png";
export const BLOG_POST_29_SECTION5 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+29+-+section+5.png";
export const BLOG_POST_29_MAIN =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+29.png";

export const BLOG_POST_30_MAIN =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+30.png";
export const BLOG_POST_30_SECTION1 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+30+-+section+1.png";
export const BLOG_POST_30_SECTION3 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+30+-+section+3.png";
export const BLOG_POST_30_SECTION6 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+30+-+section+6.png";

// Blog 31 images

export const BLOG_POST_31_MAIN =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+31.png";
export const BLOG_POST_31_SECTION2 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+31+-+section+2.png";
export const BLOG_POST_31_SECTION5 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+31+-+section+5.png";
export const BLOG_POST_31_FAQ =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+31+-+FAQ.png";

// utils/images.js
export const BLOG_FAQ_IMAGE =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/faq.png";
export const BLOG_POST_32_MAIN =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+32.png";
export const BLOG_POST_32_SECTION1 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+32+-+section+1.png";
export const BLOG_POST_32_SECTION3 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+32+-+section+3.png";
export const BLOG_POST_32_SECTION5 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+32+-+section+5.png";
export const BLOG_POST_32_SECTION7 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+32+-+section+7.png";
export const BLOG_POST_32_WHATS_HOT =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+32+-+whats+really+hot+for+2025.png";

export const BLOG_POST_33_MAIN =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+33.png";
export const BLOG_POST_33_SECTION1 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+33+-+section+1.png";
export const BLOG_POST_33_SECTION3 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+33+-+section+3.png";
export const BLOG_POST_33_FAQ =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+33+-+FAQ.png";
export const BLOG_POST_33_SECTION5 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+33+-+section+5.png";

export const BLOG_POST_34_MAIN =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+34.png";
export const BLOG_POST_34_SECTION1 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+34+-+section+i.png";
export const BLOG_POST_34_SECTION2 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+34+-+section+2.png";
export const BLOG_POST_34_SECTION4 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+34+-+section+4.png";
export const BLOG_POST_34_SECTION5 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+34+-+section+5.png";
export const BLOG_POST_34_REAL_STORIES =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+34+-+real+stories.png";
export const BLOG_POST_34_FAQ =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+34+-+FAQs.png";

export const BLOG_POST_35_MAIN =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+35+new.png";
export const BLOG_POST_35_SECTION_CLASSICS =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+35+-+section+The+Classics.png";
export const BLOG_POST_35_SECTION_MODERN =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+35+-+section+Modern+Hits.png";
export const BLOG_POST_35_SECTION_REGIONAL =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+35+section+regional+flavor+.png";
export const BLOG_POST_35_SECTION_RETRO =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+35+section+retro+revival.png";
export const BLOG_POST_35_SECTION_OFFBEAT =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+35+-+section+Off+beat+and+unexpected.png";
export const BLOG_POST_35_SECTION_PROTIPS =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+35+section+pro+tips.png";
export const BLOG_POST_35_SECTION_CONCLUSION =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+35+-+section+CONCLUSION.png";
export const BLOG_FAQ =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Blog+FAQ.png";

export const BLOG_POST_36_MAIN =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+36+.png";
export const BLOG_POST_36_RAIN =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+36+section+Rain-Soaked+Mehend.png";
export const BLOG_POST_36_FLASHMOB =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+36+The+Groom%E2%80%99s+%E2%80%9CSurprise%E2%80%9D+Flash+Mob%E2%80%A6+Saved+by+a+Hypeman+MC+.png";
export const BLOG_POST_36_LED =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+36+Guests+become+the+show.png";
export const BLOG_POST_36_SUFI =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+36+Sufi+Night+After+Sangeet+Canceled.png";
export const BLOG_POST_36_BROKEN_SOUND =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+36+Broken+Sound+System.png";
export const BLOG_POST_36_MAGICIAN =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+36+Magician+Saved+a+Dead+Sangeet+Energy.png";
export const BLOG_POST_36_WHATYOULARN =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+36+What+You+Can+Learn+from+These+Last-Minute+Saves.png";

export const BLOG_POST_37_MAIN =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+37.png";
export const BLOG_POST_37_PART1 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+37+Part+1.png";
export const BLOG_POST_37_PART2 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+37+Part+2.png";
export const BLOG_POST_37_OUTFITS =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+37+Outfits+%26+Styling+(~10%E2%80%9320%25).png";
export const BLOG_POST_37_PART4 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+37+Part+4+.png";

export const BLOG_POST_38_MAIN =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+38+.png";
export const BLOG_POST_38_HOW_TO_BOOK =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+38++How+to+book+artist.png";
export const BLOG_POST_38_COMEDY =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+38+Comedy+Anchors++Stand-Up+Comedians.png";
export const BLOG_POST_38_FOLK_FUSION =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+38+Folk+Fusion+Groups++.png";
export const BLOG_POST_38_CARICATURE =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+38+Live+Digital+Caricature+Artists++.png";
export const BLOG_POST_38_WHY_UNDERBOOKED =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+38+Why+These+Artists+Don%E2%80%99t+Get+Booked+Enough+.png";

export const BLOG_POST_39_MAIN =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+39.png";
export const BLOG_POST_39_MISTAKES =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+39+Mistakes+Most+College+Committees+Make.png";
export const BLOG_POST_39_CHECKLIST =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+39+Planning+Checklist+for+College+Fest+Entertainment.png";
export const BLOG_POST_39_THREETIER =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+39+Use+the+3-Tier+Artist+Format+to+Build+Momentum.png";

export const BLOG_POST_40_MAIN =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+40.png";
export const BLOG_POST_40_PUPPET =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+40+.+Puppet+Show+Artists.png";
export const BLOG_POST_40_ACOUSTIC =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+40+Acoustic+Bands+or+Solo+Musicians.png";
export const BLOG_POST_40_CLOWN =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+40+Clowns+%26+Balloon+Twisters.png";
export const BLOG_POST_40_DANCE =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+40+Dance+Troupes+(Classical+or+Fusion).png";
export const BLOG_POST_40_CARICATURE =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+40+Live+Sketch+Artists++Digital+Caricaturists.png";

export const BLOG_POST_41_MAIN =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+41.png";
export const BLOG_POST_41_SECTION1 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+41+Section+1.png";
export const BLOG_POST_41_SECTION2 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+41+Section+2.png";
export const BLOG_POST_41_SECTION3 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+41+Section+3.png";
export const BLOG_POST_41_SECTION4 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+41+Section+4.png";
export const BLOG_POST_41_REDFLAGS =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+41+Section+Red+Flags.png";

export const BLOG_POST_42_MAIN =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+42.png";
export const BLOG_POST_42_SECTION1 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Part+1+The+Unspoken+Problems+in+the+Event+Industry.png";
export const BLOG_POST_42_SECTION2 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/2.+Middlemen+Markups+That+Break+Budgets.png";
export const BLOG_POST_42_SECTION3 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Part+2+What%E2%80%99s+Broken+for+Clients+(and+What+You%E2%80%99re+Wasting).png";
export const BLOG_POST_42_SECTION4 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Part+3+What%E2%80%99s+Broken+for+Artists+(And+Why+They+Burn+Out).png";
export const BLOG_POST_42_SECTION5 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Part+4+The+Solution+Artist+Next+Door.png";
export const BLOG_POST_42_SECTION6 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Part+5+Real+Cost+Savings+When+You+Book+Smart.png";
export const BLOG_POST_42_SECTION7 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/4.+No+Discovery%2C+No+Opportunity.png";

export const BLOG_POST_43_MAIN =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+43+.png";
export const BLOG_POST_43_SECTION1 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+43+Section+1.png";
export const BLOG_POST_43_SECTION2 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+43++Section+2.png";
export const BLOG_POST_43_SECTION3 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+43++Section+3.png";
export const BLOG_POST_43_SECTION4 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+43++Section+4.png";
export const BLOG_POST_43_SECTION5 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+43++Section+5.png";
export const BLOG_POST_43_SECTION6 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+43++Section+6.png";

export const BLOG_POST_44_MAIN =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+44.png";
export const BLOG_POST_44_SECTION1 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+44+Section+1.png";
export const BLOG_POST_44_SECTION2 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+44+Section+2.png";
export const BLOG_POST_44_SECTION3 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+44+Section+3.png";
export const BLOG_POST_44_SECTION5 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+44+Section+5.png";
export const BLOG_POST_44_SECTION6 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+44+Section+6.png";

// images.js
export const BLOG_POST_45_MAIN =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+45.png";
export const BLOG_POST_45_SECTION1 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+45+Section+1.png";
export const BLOG_POST_45_SECTION2 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+45+Section+2.png";
export const BLOG_POST_45_SECTION3 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+45+Section+3.png";
export const BLOG_POST_45_SECTION4 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+45+Section+4.png";

// images.js
export const BLOG_POST_46_MAIN =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+46.png";
export const BLOG_POST_46_SECTION1 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+46+section+1.png";
export const BLOG_POST_46_SECTION2 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+46+section+2.png";
export const BLOG_POST_46_SECTION3 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+46+section+3.png";
export const BLOG_POST_46_SECTION4 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+46+section+4.png";
export const BLOG_POST_46_SECTION6 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+46+section+6.png";
export const BLOG_POST_46_SECTION7 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+46+section+7.png";
export const BLOG_POST_46_SECTION9 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+46+section+9.png";

export const BLOG_POST_47_MAIN =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+47.png";
export const BLOG_POST_47_SECTION1 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+47+section+1.png";
export const BLOG_POST_47_SECTION2 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+47+section+2.png";
export const BLOG_POST_47_SECTION3 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+47+section+3.png";
export const BLOG_POST_47_SECTION4 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+47+section+4.png";
export const BLOG_POST_47_SECTION5 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+47+section+5.png";

export const BLOG_POST_48_MAIN =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+48.png";
export const BLOG_POST_48_SECTION1 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+48+section+1.png";
export const BLOG_POST_48_SECTION2 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+48+section+2.png";
export const BLOG_POST_48_SECTION3 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+48+section+3.png";
export const BLOG_POST_48_SECTION4 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+48+section+4.png";
export const BLOG_POST_48_SECTION5 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+48+section+5.png";
export const BLOG_POST_48_FAQ =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+48+FAQs.png";

export const BLOG_POST_49_MAIN =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+49.png";
export const BLOG_POST_49_SECTION1 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+49+section+1.png";
export const BLOG_POST_49_SECTION2 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+49+section+2.png";
export const BLOG_POST_49_SECTION3 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+49+section+3.png";
export const BLOG_POST_49_SECTION4 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+49+section+4.png";
export const BLOG_POST_49_SECTION5 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+49+section+5.png";
export const BLOG_POST_49_SECTION6 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+49+section+6.png";
export const BLOG_POST_49_SECTION7 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+49+section+7.png";
export const BLOG_POST_49_SECTION8 =
  "https://andmediabucket.s3.us-east-1.amazonaws.com/blog-images/Post+49+section+8.png";
